import React, { useState } from "react";
import { useData } from "../../../context/DataContext";
import ImageUploadField from "../../../utils/ImageUploadField";
import { confirmDelete, successToast } from "../../../utils/dialog";

export default function AdminSpecialOffers() {
  const { specialOffers, addSpecialOffer, updateSpecialOffer, deleteSpecialOffer } = useData();

  const [newOffer, setNewOffer] = useState({
    title: "",
    discount: "",
    image: "",
    size: "h-48 md:h-64", // Default size
  });

  const [file, setFile] = useState(null); // File for upload
  const [editingOffer, setEditingOffer] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOffer((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]); // Set the selected file
  };

  const handleAddOffer = async () => {
    if (newOffer.title && newOffer.discount) {
      await addSpecialOffer(newOffer, file); // Pass the file to the method
      setNewOffer({ title: "", discount: "", image: "", size: "h-48 md:h-64" });
      setFile(null); // Reset the file input
    }
  };

  const handleUpdateOffer = async () => {
    if (editingOffer && newOffer.title && newOffer.discount) {
      await updateSpecialOffer(editingOffer.id, newOffer, file); // Pass the file to the method
      setEditingOffer(null);
      setNewOffer({ title: "", discount: "", image: "", size: "h-48 md:h-64" });
      setFile(null); // Reset the file input
    }
  };

  const handleEdit = (offer) => {
    setEditingOffer(offer);
    setNewOffer({ title: offer.title, discount: offer.discount, image: offer.image, size: offer.size });
  };

  const handleDelete = async (id) => {
    if (
      await confirmDelete({
        title: "Delete Special Offer?",
        text: "This special offer will be permanently deleted.",
      })
    ) {
      await deleteSpecialOffer(id);
      successToast("Special offer deleted successfully.");
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Manage Special Offers</h2>

      {/* Add/Edit Form */}
      <div className="mb-6">
        <h3 className="text-xl font-semibold mb-2">{editingOffer ? "Edit Offer" : "Add New Offer"}</h3>
        <input
          type="text"
          name="title"
          placeholder="Title"
          value={newOffer.title}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <input
          type="text"
          name="discount"
          placeholder="Discount"
          value={newOffer.discount}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        />
        <select
          name="size"
          value={newOffer.size}
          onChange={handleInputChange}
          className="block w-full mb-2 p-2 border rounded"
        >
          <option value="h-48 md:h-64">Small</option>
          <option value="h-48 md:h-[33rem]">Large</option>
        </select>
        <div className="mb-3">
          <ImageUploadField
            label="Offer Image"
            hint="Recommended size: 600×400px"
            previewUrl={newOffer.image}
            file={file}
            onChange={handleFileChange}
            onClear={() => setFile(null)}
          />
        </div>
        <button
          onClick={editingOffer ? handleUpdateOffer : handleAddOffer}
          className="px-4 py-2 bg-blue-500 text-white rounded"
        >
          {editingOffer ? "Update Offer" : "Add Offer"}
        </button>
        {editingOffer && (
          <button
            onClick={() => {
              setEditingOffer(null);
              setNewOffer({ title: "", discount: "", image: "", size: "h-48 md:h-64" });
              setFile(null); // Reset the file input
            }}
            className="ml-2 px-4 py-2 bg-gray-500 text-white rounded"
          >
            Cancel
          </button>
        )}
      </div>

      {/* Offers List */}
      <div>
        <h3 className="text-xl font-semibold mb-2">Offers</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {specialOffers.map((offer) => (
            <div key={offer.id} className="p-4 border rounded shadow">
              <img
                src={offer.image}
                alt={offer.title}
                className="w-full h-32 object-cover mb-2"
              />
              <h4 className="text-lg font-bold">{offer.title}</h4>
              <p className="text-sm text-gray-600">{offer.discount}</p>
              <div className="mt-2 flex justify-between">
                <button
                  onClick={() => handleEdit(offer)}
                  className="px-3 py-1 bg-yellow-500 text-white rounded"
                >
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(offer.id)}
                  className="px-3 py-1 bg-red-500 text-white rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}